<script>
  export let text;
</script>

<footer>
  <div class="wrapper">
    <div style="height: 125px; width: 90%;">
      <img src="images/footer-logos.png" alt="Logos"/>
    </div>
    <p style="font-size:12px;width: 80%;text-align:center;margin-top:40px;margin-bottom:40px">{text}</p>
  </div>
</footer>